function isValidUrl(url) {
  const urlRegex = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w\.-]*)*\/?(\?[=&\w\.-]*)?$/;

  return urlRegex.test(url)
}

export default isValidUrl
